<template>
  <PageContainer title="Faturamento">
    <Box space="medium" class="faturamento-container">
      <form @submit.prevent="handleSubmit">
        <div class="radio">
          <span>Selecione o critério de consulta</span>

          <RadioButtons :options="consultOptions" name="consult" :modelValue="consult"
            @update:modelValue="$event => this.consult = $event" />
        </div>

        <div v-if="consult === 'invoices'" class="inputs">
          <Period legend="Período" :firstModelValue="invoicesInitialDate" :secondModelValue="invoicesFinalDate"
            @update:firstModelValue="$event => (this.invoicesInitialDate = $event)"
            @update:secondModelValue="$event => (this.invoicesFinalDate = $event)" :disabled="loading" />
        </div>

        <div v-else-if="consult === 'payments'" class="inputs">
          <Period legend="Período" :firstModelValue="paymentsInitialDate" :secondModelValue="paymentsFinalDate"
            @update:firstModelValue="$event => (this.paymentsInitialDate = $event)"
            @update:secondModelValue="$event => (this.paymentsFinalDate = $event)" :disabled="loading" />
        </div>

        <div class="buttons">
          <Button type="submit" text="Consultar" color="primary" :disabled="loading">
            <Magnify :size="18" />
          </Button>
        </div>
      </form>

      <div class="loading" v-if="loading">
        <LoadingSpinner />
      </div>

      <div v-else-if="invoices.length > 0 && !loading" class="table-container">
        <div class="summary">
          <Input legend="Total faturado no periodo:" :readonly="true" :modelValue="getTotal('faturado')" />

          <Input legend="Total faturado no periodo:" :readonly="true" :modelValue="getTotal('recebido')" />

          <Input legend="Total faturado no periodo:" :readonly="true" :modelValue="toReceive" />
        </div>

        <h3>Faturamento dor Autoescola</h3>

        <Table :headers="['Autoescola', 'Total faturado no período', 'Total recebido no período', 'A receber']">
          <tr v-for="invoice in invoices" :key="invoice.autoescola">
            <td>{{ invoice.autoescola }}</td>
            <td>{{ new Intl.NumberFormat('pt-BR', {
              style: 'currency', currency:
                'BRL'
            }).format(invoice.faturado) }}</td>
            <td>{{ new Intl.NumberFormat('pt-BR', {
              style: 'currency', currency:
                'BRL'
            }).format(invoice.recebido) }}</td>
            <td>{{ new Intl.NumberFormat('pt-BR', {
              style: 'currency', currency:
                'BRL'
            }).format(invoice.faturado - invoice.recebido) }}</td>
          </tr>
        </Table>
      </div>
    </Box>
  </PageContainer>
</template>

<script>
import PageContainer from 'core/PageContainer'
import Box from 'core/Box'
import Period from 'core/Period'
import RadioButtons from 'core/RadioButtons'
import Button from 'core/Button'
import LoadingSpinner from 'core/LoadingSpinner'
import Input from 'core/Input'
import Table from 'core/Table'

import Magnify from 'icons/Magnify'

export default {
  name: 'FaturamentoPanel',
  components: {
    PageContainer,
    Box,
    Period,
    RadioButtons,
    Button,
    LoadingSpinner,
    Input,
    Table,

    Magnify,
  },
  data() {
    return {
      consult: 'invoices',
      invoicesInitialDate: '',
      invoicesFinalDate: '',
      paymentsInitialDate: '',
      paymentsFinalDate: '',
      invoices: [],
      consultOptions: [
        { value: "invoices", label: "Faturas" },
        { value: "payments", label: "Pagamentos" },
      ],
      loading: false,
    }
  },
  computed: {
    toReceive() {
      const invoiced = this.invoices.reduce((acc, item) => acc + item.faturado, 0)
      const received = this.invoices.reduce((acc, item) => acc + item.recebido, 0)

      return new Intl.NumberFormat('pt-BR', {
        style: 'currency', currency:
          'BRL'
      }).format(invoiced - received)
    },
  },
  methods: {
    async fetchData() {
      this.loading = true

      let params

      if (this.consult === 'invoices') {
        params = {
          faturamento_inicio: this.invoicesInitialDate,
          faturamento_final: this.invoicesFinalDate,
        }
      } else {
        params = {
          pagamento_inicio: this.paymentsInitialDate,
          pagamento_final: this.paymentsFinalDate,
        }
      }

      this.$http.get(`${process.env.VUE_APP_URL_API_V2}/faturamento/faturasporperiodo`,
        {
          params,
        }
      )
        .then(res => {
          const dados = res.body.dados

          this.invoices = dados
        })
        .finally(() => {
          this.loading = false
        })
    },
    async handleSubmit() {
      if (this.validateInputs()) {
        this.fetchData()
      }
    },
    validateInputs() {
      switch (this.consult) {
        case 'invoices':
          return this.validateDate(this.invoicesInitialDate, this.invoicesFinalDate)
        case 'payments':
          return this.validateDate(this.paymentsInitialDate, this.paymentsFinalDate)
        default:
          break
      }

      return true
    },
    validateDate(initialDate, finalDate) {
      if (!initialDate || !finalDate) {
        this.$toasted.show('Preencha o todas as datas.', {
          position: 'top-right',
        })

        return false
      }

      const initial = new Date(initialDate)
      const final = new Date(finalDate)

      if (initial > final) {
        this.$toasted.show('A data inicial deve ser menor ou igual à data final.', {
          position: 'top-right',
        })

        return false
      }

      return true
    },
    getTotal(record) {
      const total = this.invoices.reduce((acc, item) => acc + item[record], 0)

      return new Intl.NumberFormat('pt-BR', {
        style: 'currency', currency:
          'BRL'
      }).format(total)
    },
  }
}
</script>

<style lang="scss" scoped>
.faturamento-container {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;

  form {
    display: flex;
    flex-direction: column;
    gap: 2.5rem;

    .radio {
      display: flex;
      flex-direction: column;
      gap: 1rem;

      span {
        font-size: 1rem;
        font-weight: 600;
        line-height: 21.82px;
        color: #606264;
      }
    }

    .inputs {
      max-width: 30rem;
    }

    .buttons {
      align-self: flex-end;

      display: flex;
      gap: 0.5rem;
    }
  }

  .loading {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .table-container {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;

    .summary {
      display: flex;
      gap: 1rem;
    }

    h3 {
      margin: 0;
      text-align: center;
      font-size: 1.25rem;
      font-weight: 700;
      color: #1C2D5A;
    }
  }
}
</style>